import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

import { SNAPPEA_TOKEN } from '@/constants';
import { startConsentSync } from '@/layouts/ConsentSync';

/**
 * Syncs Transcend consent for the signed-in session; restarts on token change, stops on sign-out
 * here or in another tab.
 */
export const useConsentSync = (sessionToken: string | null) => {
  const client = useApolloClient();

  useEffect(() => {
    if (!sessionToken || import.meta.env.VITE_CONSENT_MANAGEMENT_DISABLE_SYNC === 'true') return;

    const stop = startConsentSync(client, sessionToken);
    // A sign-out or sign-in in another tab replaces the shared token without re-rendering this tab,
    // and every request reads the token from storage, so this sync would act for a session it did
    // not start. A null key means the storage was cleared.
    const stopOnTokenChange = (event: StorageEvent) => {
      if (event.key === null || event.key === SNAPPEA_TOKEN) stop();
    };
    window.addEventListener('storage', stopOnTokenChange);

    return () => {
      window.removeEventListener('storage', stopOnTokenChange);
      stop();
    };
  }, [client, sessionToken]);
};
